import apiService from '../apiService';

const BULK_DELETE_URL = 'bulk_delete'
const bulkDeleteService = {

    async bulkDelete(payload) {
        try {
            const params = new URLSearchParams();

            payload.ids.forEach(id => params.append('ids[]', id));
            params.append('model', payload.model);

            const response = await apiService.delete(`/${BULK_DELETE_URL}?${params.toString()}`, payload);
            return response.data;
        } catch (error) {
            // A 403 or a network failure comes back without `response`.
            throw error?.response?.data || { message: error?.customMessage || 'Could not delete these records.' };
        }
    },
};

export default bulkDeleteService;
